// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = require(109)
  , $getPrototypeOf = require(74);

require(78)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});